import { createAsyncActionTypes } from '@mews/framework';
import { prefix } from '../module';

export const SEARCH_RESULT_SELECTED = prefix('SEARCH_RESULT_SELECTED');
export const SELECTED_SEARCH_RESULT_CLEARED = prefix('SELECTED_SEARCH_RESULT_CLEARED');

export const SEARCH_RESULTS_CLEARED = prefix('SEARCH_RESULTS_CLEARED');

export const SEARCH = prefix('SEARCH');
export const [SEARCH_STARTED, SEARCH_SUCCEEDED, SEARCH_FAILED] = createAsyncActionTypes(SEARCH);

export const SEARCH_MORE = prefix('SEARCH_MORE');
export const [SEARCH_MORE_STARTED, SEARCH_MORE_SUCCEEDED, SEARCH_MORE_FAILED] = createAsyncActionTypes(SEARCH_MORE);
export const SEARCH_RESETED = prefix('SEARCH_RESETED');
